const storeMap = {
  registrySettings: async () => {
    const { useRegistrySettingsStore } = await import('~/stores/registrySettings');
    return useRegistrySettingsStore();
  },
  headerBanner: async () => {
    const { useHeaderBannerStore } = await import('~/stores/headerBanner');
    return useHeaderBannerStore();
  },
};

export const getStore = async (module) => {
  if (module in storeMap) {
    return await storeMap[module]();
  }
};
